import { graphql } from 'react-relay';
export const LoomAuthStateQuery = graphql`
	query LoomAuthStateQuery {
		loomUserStatus
	}
`;
